"use client";

import { Stack, Typography, Button, Box } from "@mui/material";
import { TbFaceIdError } from "react-icons/tb";

export default function Error({ error, reset}) {
  return (
    <>
      <Box
        sx={{
          minHeight: "100svh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Stack gap={2} alignItems="center">
          <TbFaceIdError size={80} color="lightGrey" />

          <Typography color="text.secondary" fontWeight={500}>{error || "خطایی رخ داده است"}</Typography>
          <Button onClick={() => reset()}>تلاش مجدد</Button>
        </Stack>
      </Box>
    </>
  );
}
